// extracted by mini-css-extract-plugin
export default {"button":"nl-z","reviewSort":"ol-z"};